<template>
  <div>
    <table width="100%">
      <thead>
        <tr>
          <th>
            <my-header h1="Employee Bonus Report"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Month:</th>
                <td align="left" width="20">{{data[0].Month}}</td>
                <th class="bg" align="left" width="15">Year:</th>
                <td align="left" width="15">{{data[0].Year}}</td>
                <th class="bg" align="left" width="20">Date:</th>
                <td align="left" width="20">{{data[0].Date}}</td>
              </tr>
              <tr>
                <th class="bg" align="left" width="20">Method:</th>
                <td align="left" width="20">{{data[0].Method}}</td>
                <th class="bg" align="left" width="15">Batch No. :</th>
                <td align="left" width="15">{{data[0].BatchNo}}</td>
                <th class="bg" align="left" width="15">Posted:</th>
                <td align="left" width="15">{{data[0].Post}}</td>
              </tr>
            </table>

            <table border="1" width="100%" style="border-collapse:collapse; font-size: 12px; margin-top:10px">
              <thead>
                <tr>
                  <th class="bg">Sr. No.</th>
                  <th class="bg">Emp. Code</th>
                  <th class="bg">Emp. Name</th>
                  <th class="bg">Designation</th> 
                  <th class="bg">Basic</th>
                  <th class="bg">Gross</th>
                  <th class="bg">Percentage</th>
                  <th class="bg">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in data">
                  <td align="center">{{ind+1 }}</td>
                  <td>{{item.EmpCode}}</td>
                  <td>{{item.EmpName}}</td>
                  <td>{{item.desig}}</td>
                  <td align="right">{{item.Basic}}</td>
                  <td align="right">{{item.Gross}}</td>
                  <td align="right">{{item.Percentage}}</td>
                  <td align="right">{{(item.Amount).toLocaleString()}}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/api/PayrollApi/getEmployeeBonusData')
          .then(function (res) {
            vm.data = res.data.lst;
          })
      }
    }
  })
</script>
<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/payroll/employeeBonusPrint.vue